import React, { memo } from "react";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { ENTITY_TYPES } from "../../utils";
import OrderFooterActions from "./OrderFooterActions";
import PlanogramFooterActions from "./PlanogramFooterActions";

const ActionFooterContainerSx = {
  marginTop: 0,
  mb: 1,
  display: "flex",
  alignItems: "center",
  padding: 1,
};

function ActionsFooter({
  onSave = () => {},
  onReset = () => {},
  disableSave = false,
  onCreatePONumbers = () => {},
  onSaveDates = () => {},
  onDeleteDates = () => {},
}) {
  const entityType = useSelector((store) => store.global.settings.entityType);

  return (
    <Grid container spacing={1} sx={ActionFooterContainerSx}>
      {entityType === ENTITY_TYPES.planogram ? (
        <PlanogramFooterActions
          onSave={onSave}
          onReset={onReset}
          disableSave={disableSave}
        />
      ) : (
        <OrderFooterActions
          disableActions={disableSave}
          onReset={onReset}
          onCreatePONumbers={onCreatePONumbers}
          onSaveDates={onSaveDates}
          onDeleteDates={onDeleteDates}
        />
      )}
    </Grid>
  );
}

export default memo(ActionsFooter);
